import React from 'react'
import UserHeader from '../partials/UserHeader'
import MainMenu from '../partials/MainMenu'

const UserLayout = ({children}) => {
  return (
    <div className='w-full'>
        <UserHeader />
        <MainMenu />  
        <div className='mt-5 px-5 xl:px-32 2xl:px-44'>
            {children}
        </div>  
    </div>
  )
}

export default UserLayout